import { Handle, Position } from 'reactflow';
import { NodeProps } from 'reactflow';
import { SubFlow } from '../../configLookup/components/Props';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import styles from '../configInfo.module.css';

function SubFlowNode({ data }: NodeProps<SubFlow>) {
  return (
    <div>
      <Handle type="target" position={Position.Top} isConnectable={false} />
      <div>
        <Card className={styles.subFlowNode}>
          <CardContent>
            <Typography variant="h4">
              <b>{data.name}</b>
            </Typography>
            <Typography variant="h6">Type: {data.subFlowType}</Typography>
            <Typography variant="h6"> Description:</Typography>
            <Typography sx={{ wordBreak: 'break-word' }}>{data.subFlowDescription || 'N/A'}</Typography>
            <Typography variant="h6">Ordinal: {data.ordinal}</Typography>
          </CardContent>
        </Card>
        <Handle type="source" position={Position.Bottom} isConnectable={false} />
      </div>
    </div>
  );
}

export default SubFlowNode;
